/* ─── MAIN NAV: mega menu (desktop) + drawer (mobile). Markup from snippets/xanthos-mega-nav.liquid ─── */
(function () {
  var nav = document.getElementById('xnav');
  if (!nav) return;
  var toggle = nav.querySelector('.xnav-toggle');
  var drawer = nav.querySelector('.xnav-drawer');
  var closeBtn = nav.querySelector('.xnav-close');
  var overlay = nav.querySelector('.xnav-overlay');
  var items = Array.prototype.slice.call(nav.querySelectorAll('.xnav-item'));
  var desktopMQ = window.matchMedia('(min-width: 1100px)');
  var hoverMQ = window.matchMedia('(hover: hover)');
  var openItem = null, openTimer = null, closeTimer = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

  function isDesktop() { return desktopMQ.matches; }
  function panelOf(item) { return item.querySelector(':scope > .xnav-panel'); }
  function caretOf(item) { return item.querySelector(':scope > .xnav-caret'); }

  function setOpen(item, open) {
    var panel = panelOf(item), caret = caretOf(item);
    if (!panel) return;
    panel.hidden = !open;
    item.classList.toggle('is-open', open);
    if (caret) caret.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && isDesktop() && panel.classList.contains('xnav-panel--dropdown')) {
      /* keep narrow dropdowns inside the viewport */
      panel.classList.remove('xnav-panel--right');
      var r = panel.getBoundingClientRect();
      if (r.right > window.innerWidth - 8) panel.classList.add('xnav-panel--right');
    }
  }
  function closeAll(except) {
    items.forEach(function (it) { if (it !== except && it.classList.contains('is-open')) setOpen(it, false); });
    if (openItem && openItem !== except) openItem = null;
  }
  function openPanel(item) {
    if (isDesktop()) closeAll(item);           /* one panel at a time on desktop; accordion may hold several on mobile */
    setOpen(item, true); openItem = item;
  }
  function togglePanel(item) {
    if (item.classList.contains('is-open')) { setOpen(item, false); if (openItem === item) openItem = null; }
    else openPanel(item);
  }

  items.forEach(function (item) {
    var link = item.querySelector(':scope > .xnav-link');
    var caret = caretOf(item);
    if (!panelOf(item)) return;

    caret.addEventListener('click', function () { togglePanel(item); });

    /* Desktop: first click on the label opens the panel; a click while open follows the link. Mobile: label is a plain link. */
    link.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      if (!item.classList.contains('is-open')) { e.preventDefault(); openPanel(item); }
    });

    /* Hover intent (pointer devices, desktop only). Panel is inside the item, so there is no gap to cross. */
    item.addEventListener('mouseenter', function () {
      if (!isDesktop() || !hoverMQ.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      var delay = openItem ? 0 : 120;
      openTimer = setTimeout(function () { openPanel(item); }, delay);
    });
    item.addEventListener('mouseleave', function () {
      if (!isDesktop() || !hoverMQ.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { if (item.classList.contains('is-open')) { setOpen(item, false); if (openItem === item) openItem = null; } }, 200);
    });

    /* Close when keyboard focus leaves the item (desktop). */
    item.addEventListener('focusout', function (e) {
      if (!isDesktop()) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      setOpen(item, false); if (openItem === item) openItem = null;
    });
  });

  /* Keyboard: Esc closes panel (desktop) or drawer; Left/Right move between top items. */
  nav.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (isDesktop()) {
        var it = e.target.closest('.xnav-item');
        if (it && it.classList.contains('is-open')) { setOpen(it, false); openItem = null; (caretOf(it) || it.querySelector('.xnav-link')).focus(); e.preventDefault(); }
      } else if (nav.getAttribute('data-open') === 'true') { closeDrawer(); e.preventDefault(); }
      return;
    }
    if (isDesktop() && (e.key === 'ArrowRight' || e.key === 'ArrowLeft') && e.target.classList.contains('xnav-link')) {
      var idx = items.indexOf(e.target.closest('.xnav-item'));
      var next = items[(idx + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length];
      next.querySelector('.xnav-link').focus(); e.preventDefault();
    }
    /* Focus trap inside the drawer */
    if (!isDesktop() && e.key === 'Tab' && nav.getAttribute('data-open') === 'true') {
      var f = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  });

  document.addEventListener('click', function (e) {
    if (isDesktop() && openItem && !nav.contains(e.target)) closeAll(null);
  });

  /* Drawer */
  var behind = [document.getElementById('main'), document.getElementById('footer-group')];
  function openDrawer() {
    nav.setAttribute('data-open', 'true');
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true');
    document.body.style.overflow = 'hidden';
    behind.forEach(function (el) { if (el) el.setAttribute('inert', ''); });
    closeBtn.focus();
  }
  function closeDrawer() {
    nav.setAttribute('data-open', 'false');
    toggle.setAttribute('aria-expanded', 'false');
    drawer.removeAttribute('role'); drawer.removeAttribute('aria-modal');
    document.body.style.overflow = '';
    behind.forEach(function (el) { if (el) el.removeAttribute('inert'); });
    toggle.focus();
  }
  toggle.addEventListener('click', function () { nav.getAttribute('data-open') === 'true' ? closeDrawer() : openDrawer(); });
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  /* Reset state when crossing the breakpoint. */
  function onBreakpoint() {
    closeAll(null);
    if (isDesktop() && nav.getAttribute('data-open') === 'true') closeDrawer();
  }
  if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', onBreakpoint); else desktopMQ.addListener(onBreakpoint);
})();

/* ─── PREDICTIVE SEARCH ─── */
var xsearchTimer = null;
var xsearchCache = {};

function openSearch() {
  document.getElementById('xsearch-overlay').classList.add('active');
  document.getElementById('xsearch-panel').classList.add('active');
  document.body.style.overflow = 'hidden';
  setTimeout(function() {
    document.getElementById('xsearch-input').focus();
  }, 100);
}

function closeSearch() {
  document.getElementById('xsearch-overlay').classList.remove('active');
  document.getElementById('xsearch-panel').classList.remove('active');
  document.body.style.overflow = '';
}

function clearSearch() {
  var input = document.getElementById('xsearch-input');
  input.value = '';
  input.focus();
  document.getElementById('xsearch-clear').classList.remove('visible');
  document.getElementById('xsearch-popular').style.display = '';
  document.getElementById('xsearch-results').classList.remove('active');
  document.getElementById('xsearch-loading').classList.remove('active');
}

function searchTag(e, term) {
  e.preventDefault();
  var input = document.getElementById('xsearch-input');
  input.value = term;
  input.dispatchEvent(new Event('input'));
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && document.getElementById('xsearch-panel').classList.contains('active')) {
    closeSearch();
  }
  // Ctrl+K or Cmd+K to open search
  if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
    e.preventDefault();
    openSearch();
  }
});

document.getElementById('xsearch-input').addEventListener('input', function() {
  var q = this.value.trim();
  var clearBtn = document.getElementById('xsearch-clear');
  var popular = document.getElementById('xsearch-popular');
  var results = document.getElementById('xsearch-results');
  var loading = document.getElementById('xsearch-loading');

  if (q.length > 0) {
    clearBtn.classList.add('visible');
  } else {
    clearBtn.classList.remove('visible');
  }

  if (q.length < 2) {
    popular.style.display = '';
    results.classList.remove('active');
    loading.classList.remove('active');
    return;
  }

  popular.style.display = 'none';

  if (xsearchTimer) clearTimeout(xsearchTimer);
  xsearchTimer = setTimeout(function() {
    fetchPredictive(q);
  }, 250);
});

async function fetchPredictive(q) {
  var results = document.getElementById('xsearch-results');
  var loading = document.getElementById('xsearch-loading');

  if (xsearchCache[q]) {
    renderResults(xsearchCache[q], q);
    return;
  }

  loading.classList.add('active');
  results.classList.remove('active');

  try {
    var url = window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
    var resp = await fetch(url);
    if (!resp.ok) throw new Error('Search failed');
    var data = await resp.json();
    xsearchCache[q] = data;
    renderResults(data, q);
  } catch (err) {
    loading.classList.remove('active');
    results.innerHTML = '<div class="xsearch-no-results"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg><p>Something went wrong. Please try again.</p></div>';
    results.classList.add('active');
  }
}

function renderResults(data, q) {
  var results = document.getElementById('xsearch-results');
  var loading = document.getElementById('xsearch-loading');
  loading.classList.remove('active');

  var res = data.resources.results;
  var queries = res.queries || [];
  var products = res.products || [];
  var collections = res.collections || [];
  var html = '';

  if (queries.length === 0 && products.length === 0 && collections.length === 0) {
    html = '<div class="xsearch-no-results"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg><p>No results found for "' + escapeHtml(q) + '"</p></div>';
    results.innerHTML = html;
    results.classList.add('active');
    return;
  }

  // Suggestions
  if (queries.length > 0) {
    html += '<div class="xsearch-suggestions">';
    html += '<div class="xsearch-section-title">Suggestions</div>';
    queries.forEach(function(query) {
      html += '<a href="/search?type=product&q=' + encodeURIComponent(query.text) + '" class="xsearch-suggestion-item">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';
      html += query.styled_text;
      html += '</a>';
    });
    html += '</div>';
  }

  // Collections
  if (collections.length > 0) {
    html += '<div class="xsearch-collections">';
    html += '<div class="xsearch-section-title">Categories</div>';
    collections.forEach(function(col) {
      html += '<a href="' + col.url + '" class="xsearch-collection-item">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>';
      html += '<span>' + escapeHtml(col.title) + '</span>';
      html += '<svg class="xsearch-coll-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
      html += '</a>';
    });
    html += '</div>';
  }

  // Products
  if (products.length > 0) {
    html += '<div class="xsearch-products">';
    html += '<div class="xsearch-section-title">Products</div>';
    products.forEach(function(product) {
      var imgHtml = '';
      if (product.featured_image && product.featured_image.url) {
        imgHtml = '<img src="' + product.featured_image.url.replace(/(\.\w+)\?/, '_200x200$1?') + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
      }
      var priceHtml = '';
      if (product.compare_at_price_max && parseFloat(product.compare_at_price_max) > parseFloat(product.price)) {
        priceHtml = product.price + '<span class="was">' + product.compare_at_price_max + '</span>';
      } else {
        priceHtml = product.price;
      }
      html += '<a href="' + product.url + '" class="xsearch-product">';
      html += '<div class="xsearch-product-img">' + imgHtml + '</div>';
      html += '<div class="xsearch-product-info">';
      html += '<div class="xsearch-product-title">' + escapeHtml(product.title) + '</div>';
      html += '<div class="xsearch-product-price">' + priceHtml + '</div>';
      html += '</div></a>';
    });
    html += '</div>';
  }

  // View all
  html += '<a href="/search?type=product&q=' + encodeURIComponent(q) + '" class="xsearch-view-all">';
  html += 'View all results for "' + escapeHtml(q) + '"';
  html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
  html += '</a>';

  results.innerHTML = html;
  results.classList.add('active');
}

function escapeHtml(s) {
  var d = document.createElement('div');
  d.textContent = s;
  return d.innerHTML;
}

